import { Action } from 'redux';
import { IAsynchronouslyLoadedValue, PromotionMap } from '../types';

export const OFFLINE_PROMOTIONS_CHANGED = 'offlinePromotions/changed';

export interface ChangeOfflinePromotionsAction extends Action {
    type: typeof OFFLINE_PROMOTIONS_CHANGED;
    payload: IAsynchronouslyLoadedValue<PromotionMap>;
}

export type PromotionActions = ChangeOfflinePromotionsAction;
